
import PRIVILEGE_MAP from './privilege';
const { COMMENT, COMMODITY, ORDER, STORE, STAFF, TRADE, DEVICE, ACCOUNT, BUSINESS, SETTLE } = PRIVILEGE_MAP;
/*
 * 模拟菜单，整个左侧导航栏的配置都在这,dataType字段与functions中的目录同名代表一个module
 * -- name：模块名称
 * -- dataType: 模块标识
 * -- isModule: 是否为路由模块
 * -- dtos: 子级
 *
 * shopTypeNo: 指定类型店铺有权查看, 1496903047847727111 - 食堂类型
 * shopUserRole: 指定角色有权查看，1-管理店铺 2-服务店铺 3-配送店铺 4-工作店铺
 * 若无shopTypeNo且为shopUserRole限制的，则为公开路由
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 15:42:05
 * @Last Modified by: fan.li@zuolin.com
 *
 */

const mockMenu = [
	{
		name: '店铺首页',
		dataType: 'trade-dashboard',
		isModule: true,
		privilegeId: TRADE.TRADE_OVERVIEW,
	},
	/////////////////////////////////////// 商品管理
	{
		name: '商品管理',
		dataType: 'commodity-manage',
		isModule: false,
		// privilegeId: 9999990001001,
		dtos: [
			{
				name: '商品列表',
				dataType: 'commodity-list',
				isModule: true,
				privilegeId: COMMODITY.COMMODITY_VIEW,
			},
			{
				name: '商品分类',
				dataType: 'commodity-classify',
				isModule: true,
				privilegeId: COMMODITY.COMMODITY_VIEW,
			},
			{
				name: '商品属性',
				dataType: 'good-property',
				isModule: true,
				privilegeId: COMMODITY.COMMODITY_VIEW,
			},
			{
				name: '周菜谱',
				dataType: 'cookbook-manage',
				isModule: true,
				storeTypes: [2],
			},
		],
	},
	{
		name: '订单管理',
		dataType: 'order-management',
		isModule: false,
		// privilegeId: 9999990001002,
		dtos: [
			{
				name: '交易记录',
				dataType: 'orders-manage',
				isModule: true,
				privilegeId: ORDER.ORDER_VIEW,
			},
			{
				name: '退款售后',
				dataType: 'refund-manage',
				isModule: true,
				privilegeId: ORDER.REFUND_VIEW,
			},
			{
				name: '订单评价',
				dataType: 'comment-manage',
				isModule: true,
				privilegeId: COMMENT.EVALUATE_VIEW,
			},
		],
	},
	{
		name: '财务管理',
		dataType: 'settlement-manage',
		isModule: false,
		// privilegeId: 9999990001004,
		dtos: [
			{
				name: '商户主页',
				dataType: 'merchant-home',
				isModule: true,
				privilegeId: ACCOUNT.ACCOUNT_HOMEPAGE_OVERVIEW,
			},
			{
				name: '账务明细',
				dataType: 'financial-details',
				isModule: true,
				merchantStatus: [2],
				privilegeId: ACCOUNT.FINANCE_DETAIL_OVERVIEW,
			},
			{
				name: '交易查询',
				dataType: 'trade-inquiries',
				isModule: true,
				merchantStatus: [2],
				privilegeId: ACCOUNT.TRADE_DETAIL_OVERVIEW,
			},
			// {
			// 	name: '对账单',
			// 	dataType: 'shop-bill',
			// 	isModule: true,
			// 	privilegeId: SETTLE.STORE_SETTLED_MERCHANT_BILL_VIEW,
			// },
			{
				name: '对账结算',
				dataType: 'shop-settlement',
				isModule: true,
				privilegeId: SETTLE.STORE_SETTLED_MERCHANT_BILL_VIEW,
			},
			{
				name: '销售分餐汇总 ',
				dataType: 'sales-catering-summary',
				isModule: true,
				storeTypes: [2]
			}
		],
	},
	{
		name: '营销活动',
		dataType: 'marketing-activity',
		isModule: false,
		// privilegeId: 9999990001006,
		merchantStatus: [2],
		dtos: [
			{
				name: '活动促销',
				dataType: 'activity-promotion',
				isModule: true,
				merchantStatus: [2],
				privilegeId: BUSINESS.BUSINESS_ACTIVITY_OVERVIEW,
			},
			{
				name: '卡券促销',
				dataType: 'cardcoupon-promotion',
				isModule: true,
				merchantStatus: [2],
				privilegeId: BUSINESS.BUSINESS_COUPON_OVERVIEW,
			},
		],
	},
	{
		name: '设备管理',
		dataType: 'device-manage',
		isModule: false,
		dtos: [
			{
				name: '打印机管理',
				dataType: 'print-manage',
				isModule: true,
				privilegeId: DEVICE.DEVICE_VIEW,
			},
			{
				name: '收银机管理',
				dataType: 'cashier-manage',
				isModule: true,
				privilegeId: DEVICE.CASHIER_VIEW,
			},
		],
	},
	{
		name: '员工管理',
		dataType: 'staff-manage',
		isModule: false,
		// privilegeId: 9999990001008,
		privilegeId: STAFF.STORE_USER_MANAGEMENT,
		dtos: [
			{
				name: '岗位管理',
				dataType: 'job-manage',
				isModule: true,
			},
			{
				name: '账号管理',
				dataType: 'staff-manage',
				isModule: true,
			},
		],
	},
	{
		name: '门店设置',
		dataType: 'shop-manage',
		isModule: false,
		// privilegeId: 9999990001009,
		dtos: [
			{
				name: '基础信息',
				dataType: 'shop-manage',
				isModule: true,
				privilegeId: STORE.STORE_VIEW,
			},
			{
				name: '站点管理',
				dataType: 'station-manage',
				isModule: true,
				privilegeId: STORE.STATION_VIEW,
			},
			{
				name: '预订管理',
				dataType: 'delivery-manage',
				isModule: true,
				privilegeId: STORE.BOOKING_MANAGEMENT,
			},
			{
				name: '档口管理',
				dataType: 'shopitem-manage',
				isModule: true,
				privilegeId: STORE.STALL_VIEW,
			},
			{
				name: '桌号管理',
				dataType: 'table-manage',
				isModule: true,
				privilegeId: STORE.TABLE_NO,
			},
		],
	},
];

export default mockMenu;
